import { Navigate, NavLink, Route, Routes, useLocation } from 'react-router-dom';
import { AlertTriangle, BrainCircuit, LayoutDashboard, Settings2 } from 'lucide-react';
import InterpreterDashboard from './InterpreterDashboard';
import InterpreterMappingsTab from './InterpreterMappingsTab';
import InterpreterDlqTriageTab from './InterpreterDlqTriageTab';
import InterpreterSchemasTab from './InterpreterSchemasTab';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '', icon: LayoutDashboard },
  { label: 'Mappings', path: 'mappings', icon: Settings2 },
  { label: 'DLQ / Triage', path: 'triage', icon: AlertTriangle },
  { label: 'Schemas', path: 'schemas', icon: BrainCircuit },
] as const;

function NavBar() {
  const location = useLocation();
  const base = '/interpreter';
  const sub = location.pathname.replace(base, '').replace(/^\//, '').split('/')[0] || '';

  return (
    <div className="flex items-center gap-1 px-6 pt-5 pb-2">
      <div className="flex items-center gap-2 mr-6">
        <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
          <BrainCircuit className="w-4 h-4 text-white" />
        </div>
        <span className="text-lg font-semibold text-gray-900">Interpreter</span>
      </div>

      <nav className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
        {NAV_ITEMS.map((item) => {
          const isActive = sub === item.path || (item.path === '' && sub === '');
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path === '' ? base : `${base}/${item.path}`}
              end={item.path === ''}
              className={`
                flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
                ${isActive
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'}
              `}
            >
              <Icon className="w-3.5 h-3.5" />
              {item.label}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}

export default function InterpreterRouter() {
  return (
    <div className="h-full flex flex-col">
      <NavBar />
      <div className="flex-1 min-h-0 px-6 pb-6 overflow-auto">
        <Routes>
          <Route index element={<InterpreterDashboard />} />
          <Route path="mappings" element={<InterpreterMappingsTab />} />
          <Route path="triage" element={<InterpreterDlqTriageTab />} />
          <Route path="schemas" element={<InterpreterSchemasTab />} />
          <Route path="*" element={<Navigate to="/interpreter" replace />} />
        </Routes>
      </div>
    </div>
  );
}
